import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const OutputScenarioContainer = styled(Box)({
  marginTop: "1%",
});

export const StickyContainer = styled("div")({
  position: "sticky",
  maxWidth: "1265.01px",
  marginTop: "82px",
  margin: "1% auto",
  top: 55,
  zIndex: 10,
  backgroundColor: "white",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
});
